export default __webpack_public_path__ + "images/92e2ced21ede41825a593b17d8fffd80-buddhism.jpg";